/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/lodash.js"/>
/// <reference path="/js/global.js"/>

(function($, _) {
  var ns = nspace("ccc.components.ui");

  /**
   * Offers common functionality for all consumers of colorboxes.
   */
  ns.Colorbox = function(formDefinitions, sizes, classNames, onPost) {
    var self = this;

    // make all passed parameter properties each an instance property
    _.each(_.extend({}, formDefinitions, sizes, classNames, onPost), function(
      value,
      key
    ) {
      self[key] = value;
    });

    _.bindAll(self);

    self.initialize();
  };

  (function(proto) {
    /**
     * Initializes the colorbox.
     */
    proto.initialize = function() {
      var self = this,
        updateLayout;

      // set up resize after input's change (in the event of a form validation)
      self.$initialForm.on("keyup click blur", "input", function() {
        setTimeout(function() {
          self.$link.colorbox.resize();
        }, 50);
      });

      // set up colorbox resize after window resize
      updateLayout = _.debounce(function() {
        self.$link.colorbox.resize({ width: self.optimalWidth() });
      }, 200);
      $(window).resize(updateLayout);
    };

    /**
     * A flag that determines whether the colorbox is in the middle of doing something. True if it's not.
     */
    proto.willDisplayOnLoad = true;

    /**
     * Calculates the optimal width for the colorbox window.
     */
    proto.optimalWidth = function() {
      var windowWidth = $(window).width(),
        width,
        self = this;

      if (windowWidth > self.maxWidth) {
        width = self.maxWidth;
      }
      else if (windowWidth < self.minWidth) {
        width = self.minWidth;
      }
      else {
        width = self.percentageWidth;
      }

      return width;
    };

    /**
     * Displays the colorbox.
     */
    proto.show = function(href) {
      var self = this,
        initializeColorbox;

      initializeColorbox = function() {
        if (self.$waitingForm.attr("class") !== self.visibleClass) {
          if (self.willDisplayOnLoad === true) {
            self.$initialForm
              .attr("class", self.visibleClass)
              .removeAttr("style");
            self.$successForm
              .attr("class", self.hiddenClass)
              .removeAttr("style");
            self.$failureForm
              .attr("class", self.hiddenClass)
              .removeAttr("style");
          }
          else {
            self.willDisplayOnLoad = true;
          }
        }
      };

      self.$link.colorbox({
        inline: true,
        width: self.optimalWidth(),
        onOpen: initializeColorbox,
        href: href,
        scrolling: false
      });
    };

    /**
     * POSTs data.
     */
    proto.postForm = function(data, url) {
      var self = this;

      // since we are posting now, we have to make sure
      // the original form won't display until we get a
      // response
      self.willDisplayOnLoad = false;

      self.$initialForm.attr("class", self.hiddenClass);
      self.$waitingForm.attr("class", self.visibleClass);

      $.ajax({
        type: "POST",
        url: url,
        data: data,
        success: function(success) {
          self.$waitingForm.attr("class", self.hiddenClass);

          if (success.Success === true) {
            self.$successForm.fadeIn(1500, function() {
              self.$successForm.attr("class", self.visibleClass);
              self.$mainForm[0].reset();

              if (self.onPostSuccess) {
                self.onPostSuccess(success);
              }

              // hide any remaining validation errors (another workaround - see http://stackoverflow.com/a/12749966/684271)
              $("span.field-validation-error")
                .attr("class", "field-validation-valid")
                .empty();

              self.$link.colorbox().resize();
            });
          }
          else {
            // an error message
            self.$failureForm.fadeIn(1500, function() {
              self.$failureForm.attr("class", self.visibleClass);
              if (self.onPostFailure) {
                self.onPostFailure(success);
              }
              self.$link.colorbox().resize();
            });
          }

          // if the colorbox is already open, make sure
          // colorbox is restored to normal state; otherwise
          // make sure the success box shows
          if ($("#colorbox").css("display") === "block") {
            self.willDisplayOnLoad = true;
          }
        }
      });
    };
  })(ns.Colorbox.prototype);
})(jQuery, _);
